"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilteredComponents = exports.default = void 0;
/**
 * This generates a new list of components: newComponentArr
 *
 * This function gets a list of all components and cross checks it with a list
 * of checked components.
 * @param components
 * @param filters
 * @param searchString
 */

var getFilteredComponents = function getFilteredComponents(components, filters, searchString) {
  if (filters.length === 0 && searchString.length === 0) {
    return components;
  }

  if (searchString.length >= 1 && filters.length === 0) {
    var newComponentArr = components.filter(function (component) {
      return (component.title || '').toLowerCase().includes(searchString.toLowerCase());
    });
    return newComponentArr;
  } // Make local variables available to filter's closure.


  var f = filters;
  var s = searchString; // Filter components based on filters and search string.

  var filtered = components.filter(function (component, index, comps) {
    var categories = component.categories;
    var tempValArray = [];
    Object.keys(categories).forEach(function (category) {
      Object.keys(comps[index].categories[category]).forEach(function (value) {
        tempValArray.push(comps[index].categories[category][value]);
      });
    });
    var found = f.every(function (value) {
      return tempValArray.includes(value);
    }) && comps[index].title.toLowerCase().includes(s.toLowerCase());
    return found;
  });
  return filtered;
};

exports.default = getFilteredComponents;
exports.getFilteredComponents = getFilteredComponents;